import { featureSetService } from '../services/featuresetservice.js';

export default {
  namespaced: true,
  state: {
    featureMap: {}
  },
  mutations: {
    setFeatureMap(state, feature_map) {
      state.featureMap = feature_map;
    }
  },
  getters: {
    hasFeature: state => feature => {
      return state.featureMap[feature] != undefined;
    }
  },
  actions: {
    refreshFeatureMapByURL(context, tenancy_url) {
      return featureSetService.getFeatureSetByUrl(tenancy_url).then(response => {
        context.commit("setFeatureMap", featureSetToMap(response.featureSet.features));
      });
    },
    refreshFeatureMapByEntity(context, setting) {
      return featureSetService.getFeatureSetByEntityId(setting.entity_type, setting.entity_id).then(response => {
        context.commit("setFeatureMap", featureSetToMap(response.featureSet.features));
      });
    },
    resetFeatureMap(context) {
      context.commit("setFeatureMap", {});
    }
  }
};

function featureSetToMap(feature_set) {
  let feature_map = {};

  filter_loop: for (const feature of feature_set) {
    const name = feature.featureName;
    // leave out teaser flags for features that are enabled
    if (name.endsWith("Teaser")) {
      let base_name = name.substring(0, name.length - 6);
      for (const base_feature of feature_set) {
        if (base_feature.featureName === base_name) {
          continue filter_loop;
        }
      }
    }
    feature_map[name] = feature;
  }

  return feature_map;
}


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/store/featureset.js
// module id = null
// module chunks = 